import { render, staticRenderFns } from "./NewAIIvrForm.vue?vue&type=template&id=6aa355d8&scoped=true&"
import script from "./NewAIIvrForm.vue?vue&type=script&lang=js&"
export * from "./NewAIIvrForm.vue?vue&type=script&lang=js&"
import style0 from "./NewAIIvrForm.vue?vue&type=style&index=0&id=6aa355d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa355d8",
  null
  
)

export default component.exports